import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePostHogPageView, isPostHogEnabled } from 'utils/posthog';

export const usePostHogPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (isPostHogEnabled()) {
      capturePostHogPageView();
    }
  }, [location.pathname, location.search]);
};
